import { MSQuery, MSUrl } from '../../http/utils/http.utils';

export function mapUrlAndQueryToKey(url: MSUrl, query: MSQuery | undefined): string {
  const queryKeys = Object.keys(query ?? {});
  const queryKeysSorted = queryKeys.sort();
  const queryKeyValues = queryKeysSorted.map((key) => `${key}=${query[key]}`);
  const queryKeyValuesJoined = queryKeyValues.join('&');
  const key = `${url}?${queryKeyValuesJoined}`;

  return key;
}
